import { token } from '@/common/utils/token/token.js';

export const responseInterceptors = (vm) => {
    uni.$uv.http.interceptors.response.use((res) => {
		let { data } = res;
		if(data && data.status !== 200) {
			return Promise.reject(data);
		}
    	return typeof(res.data) === 'undefined' ? {} : res.data;
    }, (err) => {
    	let { data, statusCode, errMsg, config } = err;
		if(statusCode && statusCode === 401) {
			let redirect;
			if(uni.$sk.config.tabbarIndex > -1) {
				redirect = uni.$sk.config.tabbars[uni.$sk.config.tabbarIndex];
			} else {
				let pages = getCurrentPages();
				pages = pages[pages.length - 1];
				redirect = pages.options.redirect ? pages.options.redirect : pages.$page.fullPath;
			}

			//uni.$uv.toast('请先登录');
			token.remove();
			setTimeout(() => {
				let loginPath = uni.$sk.func.getLoginPath();
				uni.$sk.jump.navigateTo(loginPath, {
					redirect: encodeURIComponent(redirect)
				});
			}, 500);
			return Promise.reject(err);
		}
		
		//数据验证错误
		if(statusCode && statusCode === 415) {
			if(config.custom.isToast == 1) {
				uni.$uv.toast(data.data[Object.keys(data.data)[0]]);
			}
			return Promise.reject(err);
		}
		
		let message = data && data.msg ? data.msg : (statusCode ? statusCode + ': ' + errMsg : (errMsg ? errMsg : '未知错误'));
		if(config.custom.isToast == 1) {
			uni.$uv.toast(message);
		}
		
    	return Promise.reject(err);
    });
}